var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Approval Inbound Customer Return"}},[_c('div',{staticClass:"vx-input-group flex"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Waiting Approval"}},[_c('tab-waiting-approval')],1),_c('vs-tab',{attrs:{"label":"Approved"}},[_c('tab-approved')],1),_c('vs-tab',{attrs:{"label":"Rejected"}},[_c('tab-rejected')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }